module.exports = __webpack_public_path__ + "images/a9870b90ea7145ea9dd301d5f2d2b8637222423a9c249287ed9dc17c38ad23c8.svg";